<!-- <section id="clients" class="clients section" style="margin-bottom: 30px; margin-top: 50px;">
    <div class="container" data-aos="fade-up" data-aos-delay="100">
        <owl-carousel-o [options]="owlCarouselOptions">
            <ng-container *ngFor="let img of images">
                <ng-template carouselSlide>
                    <img [src]="img" alt="Client Logo"
                        style="width: 130px; height: 50px; object-fit: contain; margin: 10px;">
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</section> -->
<footer class="footer-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="content">
                    <div class="logo" style="width: 120px;
                height: 35px;
                object-fit: contain;
                margin-left: -40px;
                display: flex;
                align-items: center;">
                        <img src="assets/images/Minimal-Business-Logo-Reveal-f-unscreen.gif" alt="logo" />
                        <img src="assets/images/text1.png" alt="logo" style="width: 100%;
                    height: 100%;
                    border-radius: 0px;
                    margin-left: -30px !important;" />
                        <!-- <a routerLink="/"><p style="color: #ce202f;">Superior Digital</p></a> -->
                    </div>
                    <p>Superior Digital Private Limited is your trusted Apple Authorised Reseller. Receive expert advice
                        on Apple products and accessories.</p>

                    <!-- <div class="subscribe">
                        <h4>Join Newsletter</h4>
                        <form class="newsletter-form">
                            <input type="email" id="emails" class="form-control" placeholder="Your Email" name="EMAIL" required autocomplete="off">
                            <button class="box-btn" type="submit">Subscribe</button>
                        </form>
                    </div> -->

                    <ul class="social">
                        <li><a href="https://www.facebook.com/superiorsystems.in/" target="_blank"><i
                                    class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/superior_digital/" target="_blank"><i
                                    class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://x.com/superior_digi" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="https://www.linkedin.com/company/superior-digital-pvt-ltd/" target="_blank"><i
                                    class='bx bxl-linkedin'></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
               <!--  <div class="content ml-15">
                    <h3>Our Service</h3>

                    <ul class="footer-list">
                        <li><a>Post Sales Support</a></li>
                        <li><a>Annual Maintenance Contract</a></li>
                        <li><a>Per Incident Support</a></li>
                        <li><a>Dedicated Service Engineer</a></li>
                    </ul>
                </div> -->
            </div>

            <!-- <div class="col-lg-2 col-md-6">
                <div class="content">
                    <h3>Quick Links</h3>

                    <ul class="footer-list">
                        <li>Privacy & Policy</li>
                        <li>Terms & Conditions</li>
                    </ul>
                </div>
            </div> -->

            <div class="col-lg-4 col-md-6">
                <div class="content contacts">
                    <h3 class="ml-40">Contact</h3>

                    <ul class="footer-list foot-social">
                        <!-- <li><a href="tel:+1123456789"><i class="bx bx-mobile-alt"></i> +1 123 456 789</a></li> -->
                        <li><a href="tel:+91 80 2311 6047"><i class="bx bx-phone"></i>+91 80 2311 6047</a></li>
                        <!-- <li><a href="mailto:hello&#64;aiva.com"><i class="bx bxs-envelope"></i> hello&#64;aiva.com</a></li> -->
                        <li><a href="mailto:enquiry&#64;superiorsystems.in"><i
                                    class="bx bxs-envelope"></i>enquiry&#64;superiorsystems.in</a></li>
                        <li><i class="bx bxs-map"></i>No. 111, Ground Floor, 6th Main, MC Layout, MRCR Extn.,
                            Vijayanagar, Bangalore – 560040</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copy-area">
        <div class="container">
            <div class="row">
                <!-- <div class="col-lg-6">
                    <ul class="menu">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/about">About</a></li>
                        <li><a routerLink="/solutions">Solutions</a></li>
                        <li><a routerLink="/case">Case Studies</a></li>
                        <li><a routerLink="/blog">Blog</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
                </div> -->

                <div class="col-lg-12" style="text-align: center;">
                    <p>Superior Digital Pvt Ltd. &copy; 2025. All Right Reserved. Designed By <a
                            href="https://softcons.com/" target="_blank"><b>Softcons</b></a></p>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="go-top">
    <i class='bx bx-chevrons-up'></i>
    <i class='bx bx-chevrons-up'></i>
</div>